module.exports = __webpack_public_path__ + "img/show-img1.78e521b0.png";